<template>
    <div class="text-center mt-5 display-5 text-danger">
        <div class="d-flex justify-content-center mt-2 mb-3">
            <img src="../assets/logo.png" alt="logo" height="160" width="300"/>
        </div>
        Invalid username try again : )
    </div>
</template>

<script>
export default {
  name: 'InvalidUser',
};
</script>
